import { PhotoRejectionReason } from '../types';

export const formatEvidenceRejectionReason = (
  reason: string | undefined,
  obfuscateAi = false
): PhotoRejectionReason => {
  switch (reason) {
    case 'too close':
      return PhotoRejectionReason.TOO_CLOSE;
    case 'too far':
      return PhotoRejectionReason.TOO_FAR;
    case 'bad frame':
      return PhotoRejectionReason.BAD_FRAME;
    case 'bad quality':
      return PhotoRejectionReason.BAD_QUALITY;
    case 'resolution < 600x800':
      return PhotoRejectionReason.LOW_RESOLUTION;
    case 'invalid file format':
      return PhotoRejectionReason.INVALID_FORMAT;
    case 'treering':
      return PhotoRejectionReason.TREERING;
    case 'over exposed':
      return PhotoRejectionReason.OVER_EXPOSED;
    case 'under exposed':
      return PhotoRejectionReason.UNDER_EXPOSED;
    case 'ai failed to analyse':
      if (obfuscateAi) {
        return PhotoRejectionReason.ANALYSIS_IS_NOT_AVAILABLE;
      }
      return PhotoRejectionReason.AI_ANALYSIS_IS_NOT_AVAILABLE;
    default:
      return PhotoRejectionReason.LOW_QUALITY;
  }
};
